<template>
  <!-- 详情页上的修改删除按钮 -->
  <div class="iconGroup">
    <div class="btnGroupTop">
      <slot class="white--text ml-4"></slot>
      <v-btn @click="handleReturn"
             class="white--text ml-4"
             v-if="false"
             v-show="is_disabled"
             fab
             depressed
             :height="height"
             small
             color="primary">
        <v-icon>mdi-reply-outline</v-icon>
      </v-btn>
      <v-btn @click="handleEdit"
             class="white--text ml-4"
             v-show="is_disabled"
             v-if="showEdit"
             fab
             depressed
             :height="height"
             small
             color="primary">
        <!-- <v-icon>mdi-pencil-outline</v-icon> -->
        <v-icon class="material-icons">edit</v-icon>
      </v-btn>
      <v-btn class="white--text ml-4"
             v-show="is_disabled"
             v-if="show_del"
             fab
             depressed
             :height="height"
             small
             @click="handleDel"
             color="primary">
        <v-icon class="material-icons">delete</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
/**
 * @params is_disabled 整个按钮组显示隐藏 默认显示
 * @params show_del 显示删除 默认显示
 * @params showEdit 显示修改 默认显示
 * @params showReturn 显示返回 默认显示
 * @event  handleReturn 返回事件
 * @event  handleEdit 修改事件
 * @event  handleDel 删除事件
 */
export default {
  components: {},
  props: {
    height: {
      type: [String, Number],
      default: '40'
    },
    is_disabled: {
      type: Boolean,
      default: true,
    },
    show_del: {
      type: Boolean,
      default: true,
    },
    showEdit: {
      type: Boolean,
      default: true,
    },
    showReturn: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {}
  },
  created () { },
  mounted () { },
  methods: {
    handleReturn () {
      this.$emit('handleReturn')
    },
    handleEdit () {
      this.$emit('handleEdit')
    },
    handleDel () {
      this.$emit('handleDel')
    },
  },
  computed: {},
  watch: {},
}
</script>

<style scoped>
.iconGroup {
  position: relative;
}
.btnGroupTop {
  position: absolute;
  top: -65px;
  right: 10px;
  display: flex;
  align-items: center;
}
.returnBtn {
  color: #fff;
  margin-right: 10px;
  /* position: absolute;
  top: -55px;
  right: 130px; */
}
.editBtn {
  color: #fff;
  margin-right: 10px;
  /* position: absolute;
  top: -55px;
  right: 70px; */
}
.delBtn {
  color: #fff;
  /* position: absolute;
  top: -55px;
  right: 10px; */
}
</style>
